import slugify from "slugify";

export function customSlugify(string) {
    return slugify(string.replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([a-zA-Z])(\d)/g, '$1-$2').replace(/'/g, '-').toLowerCase(), { lower: true, strict: true })
}